module.exports = __webpack_public_path__ + "img/loc.4cc0370e.jpg";